var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.72501 7.16309H14C14.2761 7.16309 14.5 6.93923 14.5 6.66309C14.5 6.38694 14.2761 6.16309 14 6.16309H2.72501C2.44886 6.16309 2.22501 6.38694 2.22501 6.66309C2.22501 6.93923 2.44886 7.16309 2.72501 7.16309Z",
    fill: "#94A3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50812 14.0734C8.50275 14.1029 8.5 14.1331 8.5 14.1631L8.50005 14.1704C8.5015 14.2696 8.53243 14.3661 8.5889 14.4477C8.66439 14.5567 8.78009 14.6313 8.91056 14.655C8.94007 14.6604 8.97 14.6631 9 14.6631L9.00156 14.6631C9.24262 14.6623 9.44881 14.4897 9.49193 14.2525L11.4919 3.25253C11.4973 3.22302 11.5 3.19308 11.5 3.16309L11.4999 3.15579C11.4985 3.05659 11.4676 2.96006 11.4111 2.87848C11.3356 2.76945 11.2199 2.69487 11.0894 2.67115C11.0599 2.66579 11.03 2.66309 11 2.66309L10.9984 2.66309C10.7574 2.66384 10.5512 2.83648 10.5081 3.07364L8.50812 14.0734Z",
    fill: "#94A3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50812 14.0734C4.50275 14.1029 4.5 14.1331 4.5 14.1631L4.50005 14.1704C4.5015 14.2696 4.53243 14.3661 4.5889 14.4477C4.66439 14.5567 4.78009 14.6313 4.91056 14.655C4.94007 14.6604 4.97 14.6631 5 14.6631L5.00156 14.6631C5.24262 14.6623 5.44881 14.4897 5.49194 14.2525L7.49193 3.25253C7.4973 3.22302 7.5 3.19308 7.5 3.16309L7.49995 3.15579C7.4985 3.05659 7.46757 2.96006 7.4111 2.87848C7.33561 2.76945 7.21991 2.69487 7.08944 2.67115C7.05993 2.66579 7.03 2.66309 7 2.66309L6.99844 2.66309C6.75738 2.66384 6.55119 2.83648 6.50807 3.07364L4.50812 14.0734Z",
    fill: "#94A3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11.1631H13.275C13.5511 11.1631 13.775 10.9392 13.775 10.6631C13.775 10.3869 13.5511 10.1631 13.275 10.1631H2C1.72386 10.1631 1.5 10.3869 1.5 10.6631C1.5 10.9392 1.72386 11.1631 2 11.1631Z",
    fill: "#94A3BD"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.6f07e9c325eaab6247a6cff30a9a0478.svg";
export { ForwardRef as ReactComponent };